import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { EmbodimentModel } from '../embodiment-model';
import type { EmbodimentState } from '../../types';

@injectable()
export class EmbodimentModelImpl extends AbstractModel<EmbodimentState> implements EmbodimentModel {
    protected _modelData: EmbodimentState = {
        content: '',
        rules: [],
        isGenerating: false,
    };
}
